import type { User } from '@ridemaadi/types';

/** Derive gate-friendly auth flags from a session probe query (React Query v5). */
export function resolveAuthState(query: {
  data: User | null | undefined;
  isPending: boolean;
  isFetching: boolean;
}): {
  user: User | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  profileComplete: boolean;
} {
  const user = query.data ?? null;
  // Cached `null` from a prior 401 must not skip re-validation (Safari OAuth return).
  const isLoading = query.isPending || (query.isFetching && user === null);

  return {
    user,
    isLoading,
    isAuthenticated: user !== null,
    profileComplete: Boolean(user?.profileCompletedAt),
  };
}
